import 'firebase/compat/firestore';
import { Artist, ArtistId } from "../models/Artist";
import { ArtistService } from "./ArtistService";
import 'firebase/compat/firestore';
import firebase from "firebase/compat/app";
const firestore = firebase.firestore


export class ProfileService {
  static changeProfile = (update: any, artistId: ArtistId): Promise<Artist> => {
    return new Promise<Artist>((resolve, reject) => {
      const db = firestore();
      const artistDBRef = db.collection("artists").doc(artistId);
      const artistDirectoryDBRef = db.collection("directory").doc(artistId);
      // The directory copy is a projection of the profile. Rules only let
      // the profile owner update an EXISTING copy (never create one or
      // change ownerId — claimProfile does that server-side), so a failure
      // here is logged rather than failing the profile write.
      artistDirectoryDBRef.set(update, { merge: true }).then(() => {
        console.log("updated directory");
      }).catch((e) => console.warn("directory mirror not updated", e));
      artistDBRef
        .set(update, { merge: true })
        .then(() => {
          console.log("updated artist profile");
          artistDBRef
            .get()
            .then((artistDoc) => {
              // Search indexing is done by the syncArtistSearch Cloud Function.
              resolve(ArtistService.StronglyTypeArtistData(artistDoc));
            })
            .catch(reject);
        })
        .catch(reject);
    });
  };
}
